import { gql } from "apollo-boost";

export const GET_MESSAGE_TEMPLATES = gql`
query allMessageTemplates($messageType: String){
  allMessageTemplates(messageType: $messageType) {
    edges {
      node {
				seqNo
        name
        subject
        body
        description
        type
        industry
        createDate
        updateDate
      }
    }
  }
}

`;
